import React from 'react';
import PT from 'prop-types';
import TranslatorManager from 'ts-translate-js';
import tsRest from 'ts-rest-client';
import { map, startsWith, split, isEmpty } from 'lodash';
import { Card } from '../toolkit';
import { ShowMoreItems } from './showmoreitems';
import { buildProductImage, concatUrl } from '../util';
import { WaitSpinners } from 'ts-common-react-controls';
import { NoProductSection } from './othercontrols';

const tr = TranslatorManager.boundTR;

export class OrderHistory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orderHistory: [],
            loadingHistory: true,
            loadingFailed: false
        };
    }

    componentDidMount() {
        this.loadOrderHistory();
    }

    componentWillUnmount() {
        if (this.loadOrderHistoryReq) this.loadOrderHistoryReq.abort();
    }

    async loadOrderHistory() {
        this.loadOrderHistoryReq = tsRest.get(`/orderhistory/${tsapp.user.pi}`);
        try {
            const result = await this.loadOrderHistoryReq;
            this.setState({ orderHistory: result, loadingHistory: false });
        } catch(err) {
            tsRest.handleError(err);
            this.setState({ loadingHistory: false, loadingFailed: true });
        }
    }

    buildProductActionUrl(item) {
        let finalActionUrl = "";
        if (startsWith(item.actionUrl, 'http')) {
            finalActionUrl = item.actionUrl;
        } else {
            const itemId = split(item.actionUrl, '://')[1];
            finalActionUrl = concatUrl(this.props.homeUrl, `orderconfirmation/${itemId}`);
        }
        return finalActionUrl;
    }

    displayItems() {
        const _this = this;
        return map(this.state.orderHistory, (item, i) => {
            const cardActionUrl = _this.buildProductActionUrl(item);
            const { productImageUrl, isProductImage } = buildProductImage(this.props.homeUrl, item);
            const flag = item.isCancelled ? {
                label: tr("Commande annulée"), 
                type: "warning"
            } : undefined;
            return (
                <Card 
                    cardKey={"card-" + i}
                    item={item}
                    title={item.title}
                    subtitle={item.details} // Physical venue
                    details={tr("Acheté le : {purchaseDate}", {purchaseDate: item.subtitle})} // Purchase date
                    cardActionUrl={cardActionUrl}
                    productImageUrl={productImageUrl}
                    isProductImage={isProductImage}
                    buttonTitle={tr("Voir la commande")}
                    flag={flag}
                />
            );
        });
    }

    render() {
        let productsContainer;
        if (this.state.loadingHistory) // Searching results
            productsContainer = (<WaitSpinners.PleaseWaitSpinner size="md" />);
        else if (this.state.loadingFailed) // Load history error
            productsContainer = <NoProductSection message={tr("Une erreur est survenue. Veuillez réessayer.")} />;
        else if (isEmpty(this.state.orderHistory) && !this.state.loadingHistory) // Empty history
            productsContainer = <NoProductSection message={tr("Vous n'avez encore fait aucun achat.")} />;
        else { // Display order history
            const allItems = this.displayItems();
            productsContainer = <div>
                <h2>{tr("Vos commandes")}</h2>
                <ShowMoreItems items={allItems} range={15} buttonTitle={tr("Afficher plus")} />
            </div>;
        }

        return <div className={this.props.integ}>{productsContainer}</div>;
    }
}
OrderHistory.propTypes = {
    integ: PT.string,
    orderHistory: PT.object,
    homeUrl: PT.string
};
